import { formatDateMax } from './dateTimeUtils';

export const getActualTime = (): number => {
  const today = new Date();
  return today.getTime();
}

export const getTodayMinusOneYearStartDate = (): number => {
  const today = new Date();
  const year = today.getFullYear();
  today.setHours(0, 0, 0, 0);
  today.setFullYear(year - 1);
  return today.getTime();
};

export const getTodayMinusOneMonthStartDate = (): number => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const month = today.getMonth();
  today.setMonth(month - 1);
  return today.getTime();
};

export const getFirstDayOfTheMonthDate = (): number => {
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  return firstDay.getTime();
};

export const getMonthStartDate = (
  monthNumber: number,
  yearNumber: number
): number => {
  const firstDay = new Date(yearNumber, monthNumber, 1);
  return firstDay.getTime();
};

export const getMonthEndDate = (
  monthNumber: number,
  yearNumber: number
): number => {
  const lastDay = new Date(yearNumber, monthNumber + 1, 0);
  lastDay.setHours(23, 59, 59,999);
  return lastDay.getTime();
};

export const getMonthName = (numero: number) => {
  const miFecha = new Date();
  if (0 < numero && numero <= 12) {
    miFecha.setDate(1);
    miFecha.setMonth(numero - 1);
    const month = new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(
      miFecha
    );
    return month.charAt(0).toUpperCase() + month.slice(1);
  } else {
    return '';
  }
};

export const getTodayFinishDate = (): number => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  return today.getTime();
};

export const getTodayMinus15 = (): number => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() - 15);
  return date.getTime();
};

export const notAfterToday = (dateTime: number): string => {
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const todayTime = today.getTime();
  let error = '';
  if (dateTime > todayTime) {
    error = 'Las fechas no pueden superar el día de hoy';
  }

  return error;
};

export const endDateisAfterBeforeDate = (
  startDateTime: number,
  endDateTime: number
): string => {
  let error = '';

  if (endDateTime < startDateTime) {
    error = 'La fecha de fin no puede ser anterior a la fecha de inicio';
  }

  return error;
};
